import "core-js/modules/es.array.concat.js";
import { ref, computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { getRunTime } from "../utils/date";
export default {
  name: "KilaKilaFooter",
  setup: function setup() {
    var year = ref(new Date().getFullYear());
    var currentTime = ref(new Date().getTime());
    var timer = setInterval(function () {
      currentTime.value = new Date().getTime();
    }, 1000);
    var blogRunTime = computed(function () {
      var startDate = useStore().state.websiteAbout.startDate;

      var _getRunTime = getRunTime(startDate, currentTime.value),
          day = _getRunTime.day,
          hour = _getRunTime.hour,
          min = _getRunTime.min,
          second = _getRunTime.second;

      return "".concat(day, " \u5929 ").concat(hour, " \u5C0F\u65F6 ").concat(min, " \u5206 ").concat(second, " \u79D2");
    });
    onBeforeUnmount(function () {
      clearInterval(timer);
    });
    return {
      year: year,
      blogRunTime: blogRunTime
    };
  },
  props: {
    adminName: {
      type: String,
      require: true
    }
  }
};